/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Arts8Inputs */

const en__field_enum_tuda_arts8 = /** @type {(inputs: _Field_Enum_Tuda_Arts8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arts, Music, Design or Fashion`)
};

const de__field_enum_tuda_arts8 = /** @type {(inputs: _Field_Enum_Tuda_Arts8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst, Musik, Design & Mode`)
};

/**
* | output |
* | --- |
* | "Arts, Music, Design or Fashion" |
*
* @param {_Field_Enum_Tuda_Arts8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_arts8 = /** @type {((inputs?: _Field_Enum_Tuda_Arts8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Arts8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_arts8(inputs)
	return de__field_enum_tuda_arts8(inputs)
});
export { _field_enum_tuda_arts8 as "_field_enum_TUDA_ARTS" }